import React, { useEffect, useRef, useState } from 'react';
import { buildInviteUrlFromProps } from '../utils/hubupWebCreator';

export default function HubupQrView({ comp }) {
  const containerRef = useRef(null);
  const [maxSize, setMaxSize] = useState(160);
  const props = comp.props || {};
  const inviteUrl = buildInviteUrlFromProps(props);
  const qrImageUrl = props.qrImageUrl || '';
  const showLabel = props.showLabel !== false;

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return undefined;

    const update = () => {
      const rect = el.getBoundingClientRect();
      const labelSpace = showLabel && props.communityName ? 28 : 8;
      const next = Math.max(72, Math.min(rect.width, rect.height - labelSpace) - 8);
      setMaxSize(next);
    };

    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, [showLabel, props.communityName]);

  return (
    <div
      ref={containerRef}
      className="w-full h-full min-h-0 max-h-full overflow-hidden flex flex-col items-center justify-center box-border gap-2 p-2"
    >
      {qrImageUrl ? (
        <div className="shrink min-w-0 min-h-0 flex items-center justify-center max-w-full max-h-full">
          <img
            src={qrImageUrl}
            alt={props.communityName ? `QR ${props.communityName}` : 'QR HubUP'}
            className="max-w-full max-h-full w-auto h-auto object-contain drop-shadow-md"
            style={{ maxWidth: maxSize, maxHeight: maxSize }}
            draggable={false}
          />
        </div>
      ) : inviteUrl ? (
        <div className="flex flex-col items-center justify-center text-center text-xs text-muted-foreground px-3 gap-1">
          <span className="font-medium text-foreground">QR HubUP</span>
          <span>Génération en cours… Enregistrez le site ou rafraîchissez la communauté.</span>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center text-center text-xs text-muted-foreground px-2">
          <span className="font-medium">QR HubUP</span>
          <span>Sélectionnez une communauté</span>
        </div>
      )}
      {showLabel && props.communityName ? (
        <p className="text-xs font-medium text-foreground truncate max-w-full shrink-0 px-1">
          {props.communityName}
        </p>
      ) : null}
    </div>
  );
}
